var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H8.5C9.60457 2.5 10.5 3.39543 10.5 4.5V8.5C10.5 9.60457 9.60457 10.5 8.5 10.5H4.5C3.39543 10.5 2.5 9.60457 2.5 8.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5V4.5C13.5 3.39543 14.3954 2.5 15.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V8.5C21.5 9.60457 20.6046 10.5 19.5 10.5H15.5C14.3954 10.5 13.5 9.60457 13.5 8.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.5V15.5C2.5 14.3954 3.39543 13.5 4.5 13.5H8.5C9.60457 13.5 10.5 14.3954 10.5 15.5V19.5C10.5 20.6046 9.60457 21.5 8.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.5V15.5C13.5 14.3954 14.3954 13.5 15.5 13.5H19.5C20.6046 13.5 21.5 14.3954 21.5 15.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H15.5C14.3954 21.5 13.5 20.6046 13.5 19.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.578eb3fb7949db72eeeb0b2f7aac3989.svg";
export { ForwardRef as ReactComponent };